import axios from "axios";

export default {
  async list({ entityType = null, entityLabel = null, limit = 100 } = {}) {
    try {
      const params = {};
      if (entityType) params.entity_type = entityType;
      if (entityLabel) params.entity_label = entityLabel;
      if (limit !== null && limit !== undefined) params.limit = limit;
      const response = await axios.get("/audit/", { params });
      return { data: response.data };
    } catch (e) {
      return { data: [] };
    }
  },
};
